/* eslint-disable */
import Vue from 'vue'

Object.defineProperty(Vue.prototype, '$locale', {
    get: function () {
        return window.localStorage.getItem("locale");
    },
    set: function (locale) {
        this.$set(this.$root.$i18n, "locale", locale);
        window.localStorage.setItem("locale", locale);
        this.$events.$emit("locale-has-changed", locale);
    }
});